import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("legalia_lang") || "it");

  useEffect(() => {
    localStorage.setItem("legalia_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const t = translations[lang] || translations.it;

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
